import React, {
  useState,
} from "react"
import {
  Button,
  Form,
  Segment,
  Header,
  Message,
} from "semantic-ui-react"
import {
  useLocation,
  useNavigate,
} from "react-router-dom"
import axios from "axios"

const ForgottenPasswordPage = () => {
  const {
    state: {
      email: prefilledEmail = '',
    } = {},
  } = useLocation()

  const [email, setEmail] = useState(prefilledEmail)
  const [submitted, setSubmitted] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const navigate = useNavigate()

  const onSubmit = async () => {
    try {
      await axios.post("/userRequestPasswordReset", {
        email,
      })
      setSubmitted(true)
      setErrorMessage("")
    } catch (err) {
      const {
        message: errMessage = '',
        response: {
          data: {
            message = '',
          } = {},
        } = {},
      } = err
      setErrorMessage(message || errMessage || JSON.stringify(err))
    }
  }

  const onBackToLoginPress = () => {
    navigate("/")
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#1e1e1e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Segment
        padded
        raised
        style={{
          maxWidth: 400,
          width: "100%",
          backgroundColor: "#2c2f33",
          color: "white",
        }}
      >
        <Header as="h2" textAlign="center" style={{ color: "white" }}>
          Mot de passe oublié
        </Header>

        {!submitted && (
          <Form>
            <Form.Input
              label={{ children: "Email", style: { color: "white" } }}
              placeholder="votre@email.com"
              type="email"
              style={{ color: "white" }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {!!errorMessage && (
              <Message error content={errorMessage} />
            )}
            <Button
              fluid
              style={{ backgroundColor: "#2897d5", color: "white" }}
              onClick={onSubmit}
            >
              Envoyer le lien de réinitialisation
            </Button>
          </Form>
        )}

        {submitted && (
          <Message
            success
            content={`Un email de réinitialisation a été envoyé à ${email}`}
          />
        )}

        <div style={{ marginTop: "1em", textAlign: "center" }}>
          <Button basic inverted size="small" onClick={onBackToLoginPress}>
            Retour à la connexion
          </Button>
        </div>
      </Segment>
    </div>
  )
}

export default ForgottenPasswordPage
